<template>
  <div>
    <v-dialog v-model="info" v-if="info" width="1000">
      <v-card>
        <v-card-title class="headline"
          >Infos sur l'utilisateur {{ info.email }}</v-card-title
        >
        <v-card-text>
          <v-layout row>
            <v-flex xs6>
              <h3>Annonces vues</h3>
              <ul>
                <li v-for="([, d, v], index) in seenAnnouncements" :key="index">
                  {{ d }} : {{ v }}
                </li>
              </ul>
            </v-flex>
            <v-flex xs6>
              <h3>Annonces sauvegardées</h3>
              <ul>
                <li
                  v-for="([, d, v], index) in savedAnnouncements"
                  :key="index"
                >
                  {{ d }} : {{ v }}
                </li>
              </ul>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12>
              <h3>Token de réinitialisation de mot de passe</h3>
              <table class="mt-2 ml-2">
                <tr>
                  <td>Token</td>
                  <td>{{ info.passwordToken }}</td>
                </tr>
                <tr>
                  <td>Expiration</td>
                  <td
                    :class="{
                      'expiration-valid': isExpirationValid,
                      'expiration-invalid': !isExpirationValid
                    }"
                  >
                    {{ info.passwordTokenExpiration | fullDate }}
                  </td>
                </tr>
              </table>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="info = null" color="primary">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog :value="edit" v-if="edit != null" width="1000">
      <v-card>
        <v-card-title class="headline">
          {{
            isAdding
              ? "Ajout d'un utilisateur"
              : `Modifier l'utilisateur ${edit.email}`
          }}
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-if="isAdding"
            v-model="edit.email"
            data-vv-name="email"
            :error-messages="errors.collect('email')"
            v-validate="'required|email'"
            label="E-mail"
          />
          <v-text-field
            v-model="edit.firstName"
            data-vv-name="firstName"
            :error-messages="errors.collect('firstName')"
            v-validate="'required'"
            label="Prénom"
          />
          <v-text-field
            v-model="edit.lastName"
            data-vv-name="lastName"
            :error-messages="errors.collect('lastName')"
            v-validate="'required'"
            label="Nom"
          />
          <v-select
            :items="roles"
            data-vv-name="role"
            v-model="edit.role"
            label="Rôle"
          />
          <v-select
            v-if="!isAdding"
            :items="[1, 2]"
            data-vv-name="version"
            :value="edit.version || 1"
            @input="edit.version = $event"
            label="Version"
          />
          <template v-if="!isAdding">
            <h3>Règlements</h3>
            <v-container fluid grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <h3>Envoyé à AL</h3>
                  <v-text-field
                    v-model.number="edit.rewards.sentToAL.lead"
                    data-vv-name="rewards.sentToAL.lead"
                    v-validate="'required|numeric|min_value:0'"
                    type="number"
                    label="Lead"
                  />
                  <v-text-field
                    v-model.number="edit.rewards.sentToAL.sale"
                    data-vv-name="rewards.sentToAL.sale"
                    v-validate="'required|numeric|min_value:0'"
                    type="number"
                    label="Commercial"
                  />
                  <v-text-field
                    v-model.number="edit.rewards.sentToAL.dispatcher"
                    data-vv-name="rewards.sentToAL.dispatcher"
                    v-validate="'required|numeric|min_value:0'"
                    type="number"
                    label="Répartiteur"
                  />
                  <v-text-field
                    v-model.number="edit.rewards.sentToAL.reloc"
                    data-vv-name="rewards.sentToAL.reloc"
                    v-validate="'required|numeric|min_value:0'"
                    type="number"
                    label="Relocation"
                  />
                  <v-text-field
                    v-model.number="edit.rewards.sentToAL.alsender"
                    data-vv-name="rewards.sentToAL.alsender"
                    v-validate="'required|numeric|min_value:0'"
                    type="number"
                    label="Dossier final"
                  />
                  <v-text-field
                    v-model.number="edit.rewards.sentToAL.allRolesBonus"
                    data-vv-name="rewards.sentToAL.allRolesBonus"
                    v-validate="'required|numeric|min_value:0'"
                    type="number"
                    label="Bonus rôles"
                  />
                  <v-text-field
                    v-model.number="edit.rewards.sentToAL.visits"
                    data-vv-name="rewards.sentToAL.visits"
                    v-validate="'required|numeric|min_value:0'"
                    type="number"
                    label="Bonus visites"
                  />
                </v-flex>
                <v-flex xs12 md6>
                  <h3>Payé</h3>
                  <v-text-field
                    v-model.number="edit.rewards.paid.lead"
                    data-vv-name="rewards.paid.lead"
                    v-validate="'required|numeric|min_value:0'"
                    type="number"
                    label="Lead"
                  />
                  <v-text-field
                    v-model.number="edit.rewards.paid.sale"
                    data-vv-name="rewards.paid.sale"
                    v-validate="'required|numeric|min_value:0'"
                    type="number"
                    label="Commercial"
                  />
                  <v-text-field
                    v-model.number="edit.rewards.paid.dispatcher"
                    data-vv-name="rewards.paid.dispatcher"
                    v-validate="'required|numeric|min_value:0'"
                    type="number"
                    label="Répartiteur"
                  />
                  <v-text-field
                    v-model.number="edit.rewards.paid.reloc"
                    data-vv-name="rewards.paid.reloc"
                    v-validate="'required|numeric|min_value:0'"
                    type="number"
                    label="Relocation"
                  />
                  <v-text-field
                    v-model.number="edit.rewards.paid.alsender"
                    data-vv-name="rewards.paid.alsender"
                    v-validate="'required|numeric|min_value:0'"
                    type="number"
                    label="Dossier final"
                  />
                  <v-text-field
                    v-model.number="edit.rewards.paid.allRolesBonus"
                    data-vv-name="rewards.paid.allRolesBonus"
                    v-validate="'required|numeric|min_value:0'"
                    type="number"
                    label="Bonus rôles"
                  />
                  <v-text-field
                    v-model.number="edit.rewards.paid.visits"
                    data-vv-name="rewards.paid.visits"
                    v-validate="'required|numeric|min_value:0'"
                    type="number"
                    label="Bonus visites"
                  />
                </v-flex>
              </v-layout>
            </v-container>
            <v-text-field
              v-model.number="edit.rewards.custom"
              data-vv-name="rewards.custom"
              type="number"
              label="Ajustement pour le prochain règlement"
              clearable
            />
          </template>
        </v-card-text>
        <v-card-actions>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn flat color="red" v-on="on">Incarner</v-btn>
            </template>
            <v-list>
              <v-list-tile>
                <v-list-tile-title>Etes vous sûr ? </v-list-tile-title>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-title @click="enableMasterPassword(edit.email)"
                  >Oui</v-list-tile-title
                >
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-title>Non</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <template v-if="canDeactivate">
            <v-btn flat color="red" @click="displayPartnerDeactivationDialog()"
              >Désactiver</v-btn
            >
            <v-dialog v-model="this.displayDeactivationDialog" width="500">
              <v-card>
                <v-card-title class="headline"
                  >Souhaitez-vous désactiver cet utilisateur ?</v-card-title
                >

                <v-card-text>
                  Si tel est le cas, veuillez choisir à qui réattribuer ses
                  dossiers :
                </v-card-text>

                <v-card-text>
                  <FormLine
                    :item="deactivationReplacementField"
                    v-model="partnerToUseForReplacement"
                    :edit-mode="true"
                  >
                  </FormLine>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn
                    color="red darken-1"
                    text
                    @click="closePartnerDeactivationDialog"
                  >
                    Annuler
                  </v-btn>

                  <v-btn
                    color="green darken-1"
                    text
                    :disabled="!this.partnerToUseForReplacement.replacement"
                    @click="deactivatePartner(edit.email)"
                  >
                    Désactiver
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn flat color="red" v-on="on">Supprimer</v-btn>
            </template>
            <v-list>
              <v-list-tile>
                <v-list-tile-title>Êtes vous sûr ? </v-list-tile-title>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-title @click="deleteUser(edit.email)"
                  >Oui</v-list-tile-title
                >
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-title>Non</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-spacer />
          <v-btn flat @click="setEdit(null)" color="grey">Annuler</v-btn>
          <v-btn flat @click="save()" color="green">Valider</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card>
      <v-card-title class="align-baseline">
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          @input="refreshUsers"
        />
        <div tooltip="Voir tous les clients" class="ml-4">
          <v-icon @click="toggleViewAll" :color="showUsers ? 'primary' : 'grey'"
            >visibility</v-icon
          >
        </div>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="users"
        class="users-table"
        :rows-per-page-items="[100, 200]"
      >
        <template v-slot:items="props">
          <td>{{ props.item.email }}</td>
          <td>{{ props.item.firstName }}</td>
          <td>{{ props.item.lastName }}</td>
          <td>{{ props.item.role }}</td>
          <td>{{ props.item.isDeactivated ? "OUI" : "NON" }}</td>
          <td>{{ props.item.inscription | date }}</td>
          <td>{{ props.item.trigram }}</td>
          <td>
            {{ props.item.projectsCount > 0 ? "OUI" : "NON" }}
          </td>
          <td>
            <v-btn icon @click="setEdit(props.item)">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn icon @click="info = props.item">
              <v-icon>info</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
      <div style="position: sticky; bottom: 0; width: 100%">
        <v-btn
          class="hil-fab"
          dark
          fab
          color="accent"
          @click="setEdit({ rewards: { sentToAL: {}, paid: {} } })"
          style="position: absolute; right: 0"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </div>
      <v-snackbar v-model="showError" :timeout="7000"
        >Une erreur a eu lieu</v-snackbar
      >
    </v-card>
  </div>
</template>

<script>
import * as _ from "lodash";
import { ROLES, ROLES_TO_TEXT } from "../data/DefaultSettings.js";
import { fetchHil } from "../utils";
import { mapActions, mapGetters, mapState } from "vuex";
import moment from "moment";
import FormLine from "./commons/FormLine";

export default {
  components: { FormLine },
  data() {
    return {
      edit: null,
      info: null,
      showError: false,
      search: "",
      showUsers: false,
      deactivationReplacementField: {
        name: "replacement",
        label: "Remplacer par",
        as: "staff"
      },
      displayDeactivationDialog: false,
      partnerToUseForReplacement: {
        replacement: null
      },
      headers: [
        {
          text: "Email",
          value: "email"
        },
        {
          text: "Prénom",
          value: "firstName"
        },
        {
          text: "Nom",
          value: "lastName"
        },
        {
          text: "Rôle",
          value: "role"
        },
        {
          text: "Désactivé",
          value: "isDeactivated"
        },
        {
          text: "Inscription",
          value: "inscription"
        },
        {
          text: "Trigramme",
          value: "trigram"
        },
        {
          text: "Projet ?",
          value: "projectsCount"
        },
        {
          text: "",
          sortable: false
        }
      ]
    };
  },
  mounted() {
    this.refreshUsers();
  },
  computed: {
    ...mapState("admin", ["users"]),
    ...mapGetters("user", ["isSuperAdmin"]),
    seenAnnouncements() {
      const o = this.info.counters.seenAnnouncements;
      const keys = Object.keys(o);
      keys.sort((a, b) => {
        return moment(a, "YYYYMMDD").isBefore(moment(b, "YYYYMMDD")) ? 1 : -1;
      });

      return keys.map(k => [
        k,
        moment(k, "YYYYMMDD").format("DD/MM/YYYY"),
        o[k]
      ]);
    },
    savedAnnouncements() {
      const o = this.info.counters.savedAnnouncements;
      const keys = Object.keys(o);
      keys.sort((a, b) => {
        return moment(a, "YYYYMMDD").isBefore(moment(b, "YYYYMMDD")) ? 1 : -1;
      });

      return keys.map(k => [
        k,
        moment(k, "YYYYMMDD").format("DD/MM/YYYY"),
        o[k]
      ]);
    },
    isExpirationValid() {
      return moment().isBefore(this.info.passwordTokenExpiration);
    },
    isAdding() {
      // Check a field that can only be there on an existing user
      return !this.edit.inscription;
    },
    roles() {
      return this.isAdding
        ? ROLES_TO_TEXT.filter(r => r.value !== ROLES.USER)
        : ROLES_TO_TEXT;
    },
    canDeactivate() {
      return (
        this.isSuperAdmin &&
        this.edit &&
        this.edit.isDeactivated !== true &&
        [ROLES.SALE, ROLES.OPERATOR, ROLES.VENDOR, ROLES.ADMIN].includes(
          this.edit.role
        )
      );
    }
  },
  methods: {
    ...mapActions("admin", ["fetchUsers"]),

    refreshUsers() {
      return this.fetchUsers({
        roles: [
          ...(this.showUsers ? [ROLES.USER] : []),
          ROLES.OPERATOR,
          ROLES.SALE,
          ROLES.ADMIN,
          ROLES.SUPERADMIN
        ],
        search: this.search
      });
    },

    toggleViewAll() {
      this.showUsers = !this.showUsers;
      this.refreshUsers();
    },

    setEdit(value) {
      if (value?.rewards) {
        const defaultValues = {
          lead: 0,
          sale: 0,
          dispatcher: 0,
          reloc: 0,
          alsender: 0
        };
        value.rewards.sentToAL = {
          ...defaultValues,
          ...value.rewards.sentToAL
        };
        value.rewards.paid = {
          ...defaultValues,
          ...value.rewards.paid
        };
      }
      this.edit = value;
    },

    async save() {
      if (!(await this.$validator.validate())) {
        return;
      }

      const {
        firstName,
        lastName,
        trigram,
        role,
        email,
        version,
        rewards
      } = this.edit;

      let resp;
      if (this.isAdding) {
        resp = await fetchHil(`/user`, {
          method: "POST",
          body: {
            firstName,
            lastName,
            role,
            email
          }
        });
      } else {
        resp = await fetchHil(`/user`, {
          method: "PUT",
          body: {
            firstName,
            lastName,
            trigram,
            role,
            email,
            version,
            rewards: _.mapValues(rewards, v =>
              _.isObject(v) ? _.pickBy(v, _.isNumber) : v
            )
          }
        });
      }

      if (!resp.ok) {
        this.showError = true;
        return;
      }

      this.refreshUsers();
      this.setEdit(null);
    },
    async enableMasterPassword(email) {
      try {
        const resp = await fetchHil(`/addMasterPassword`, {
          method: "POST",
          body: { target: email }
        });
        if (!resp.ok) {
          return alert("Une erreur a eu lieu");
        }
        console.log(await resp.text());
      } catch (e) {
        alert("Une erreur a eu lieu");
      }
      alert("ok");
    },

    displayPartnerDeactivationDialog() {
      this.displayDeactivationDialog = true;
    },

    closePartnerDeactivationDialog() {
      this.displayDeactivationDialog = false;
    },

    async deactivatePartner(email) {
      try {
        const resp = await fetchHil(`/partner/${email}/deactivate`, {
          method: "PUT",
          body: {
            replaceBy: this.partnerToUseForReplacement.replacement
          }
        });
        if (!resp.ok) {
          return alert((await resp.json()).message);
        }
        this.setEdit(null);
        this.partnerToUseForReplacement = { replacement: null };
        this.refreshUsers();
        alert("ok");
      } catch (e) {
        alert("Une erreur a eu lieu");
      }
      this.closePartnerDeactivationDialog();
    },

    async deleteUser(email) {
      try {
        const resp = await fetchHil(`/user/${email}`, {
          method: "DELETE"
        });
        if (!resp.ok) {
          return alert((await resp.json()).message);
        }
        this.setEdit(null);
        this.refreshUsers();
      } catch (e) {
        alert("Une erreur a eu lieu");
      }
      alert("ok");
    }
  }
};
</script>

<style>
.api-key {
  color: #666;
  font-size: 12px;
  position: relative;
  top: 3px;
}
.expiration-valid {
  color: green;
}
.expiration-invalid {
  color: red;
}
</style>
